module.exports = __webpack_public_path__ + "static/media/marie-curie.c1785e3c.jpg";